// @ngInject
function stateConfig($stateProvider) {

    $stateProvider.state('base.vats.new', {
        url:'/new',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/vats/vat/vat.tpl.html',
            controller: 'VatController as vm'
        }},
        resolve: {
            vat: function() { return {}; },
            isNewVat: function() {return true;},
            accounts: accountsResolver
        }
    });

    $stateProvider.state('base.vats.vat', {
        url:'/{vatId}',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/vats/vat/vat.tpl.html',
            controller: 'VatController as vm'
        }},
        resolve: {
            vat: vatResolver,
            isNewVat: function() {return false;},
            accounts: accountsResolver
        }
    });

}

// @ngInject
function vatResolver($stateParams, VatsApiService) {
    return VatsApiService.getVat($stateParams.vatId);
}

// @ngInject
function accountsResolver(VatsApiService) {
    return VatsApiService.getAccounts();
}

// @ngInject
function languagesResolver($stateParams, VatsApiService) {
    return VatsApiService.getLanguages();
}

// @ngInject
function VatController($state, vat, loadSpinnerService, VatsApiService, ToasterService, confirmationDialogService, $translate, isNewVat, accounts) {
    var vm = this;

    //Properties
    var vatCopy = {};
    vm.vat = vat;
    vm.accounts = accounts;
    vm.isNewVat = isNewVat;
    vm.isEditing = vm.isNewVat;

    //Methods
    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveVat = saveVat;
    vm.deleteVat = deleteVat;
    vm.isVatCodeValid = isVatCodeValid;
    vm.isAllInformationValid = isAllInformationValid;
    vm.toggleDisplayForm = toggleDisplayForm;

    activate();

    function activate() {
        prepareData();
        if (vm.isNewVat) {
            vm.vat = {};
        }

        appendLocalizations(vm.vat, vm.languages);
    }

    function appendLocalizations(obj, languages) {
        if (!obj.localizations) {
            obj.localizations = [];
        }
        _.forEach(languages, function(language) {
            if (_.filter(obj.localizations, { language: { id: language.id}}).length === 0) {
                obj.localizations.push({ language: language });
            }
        });
    }

    function enableEditing() {
        vatCopy = angular.copy(vm.vat);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.vat = vatCopy;
        vm.isEditing = false;
    }

    function saveVat() {
        if (vm.isNewVat) {
            saveNewVat();
        } else {
            updateVat();
        }
    }

    function saveNewVat() {
        loadSpinnerService.start('mainSpinner');
        VatsApiService.createVat(vm.vat).then(function(response) {
            vm.vat = response;
            prepareData();
            vm.isNewVat = false;
            vm.isEditing = false;
            $state.go('base.vats.vat', {vatId: vm.vat.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updateVat() {
        loadSpinnerService.start('mainSpinner');

        VatsApiService.updateVat(vm.vat).then(function(response) {
            vm.vat = response;
            prepareData();
            vm.isNewVat = false;
            vm.isEditing = false;
            $state.go('base.vats.vat', {vatId: vm.vat.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function deleteVat() {
        confirmationDialogService
            .showDialog($translate.instant('vat.confirmDelete'))
            .then(function(confirmation) {
                if (confirmation) {
                    loadSpinnerService.start('mainSpinner');
                    VatsApiService.deleteVat(vm.vat.id).then(function(response) {
                        vm.vat = response;
                        prepareData();
                        vm.isNewVat = false;
                        vm.isEditing = false;
                        $state.go('base.vats');
                    }, function(error) {
                        console.log(error);
                        ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                    }).then(function() {
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });
    }

    function toggleDisplayForm(vat) {
        vat.showEditForm = !vat.showEditForm;
    }

    function prepareData() {
        if (vm.vat === undefined) {
            return;
        }

        vm.vatCopy = angular.copy(vm.vat);
    }

    function isAllInformationValid() {
        return isVatCodeValid();
    }

    function isVatCodeValid() {
        if (!vm.vat.vatCode) { return false; }
        return true;
    }

    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

}

angular
    .module('vats.vat', [])
    .config(stateConfig)
    .controller('VatController', VatController);
